import React from "react";
import Icon from "components/Elements/Icon/Icon";
import { useContent } from "contexts/contentContext/contentContext";
import { useUser } from "contexts/userContext/userContext";
import Button from "components/Elements/Button/Button";
import { LinkToNewTab } from "components/Elements/Link/Link";
import usePickerQueryParamActions from "components/Pages/Inbox/Picker/usePickerQueryParamActions";
import AdditionalSearchInfo from "../../Pages/Inbox/Content/AdditionalSearchInfo";
import { useSearchParams } from "react-router-dom";

import "./FullScreenMessage.scss";

const PickerFullScreenMessage = () => {
  const { getTextByKey, getHtmlByKey } = useContent();
  const { isSubscribed } = useUser();
  const { openIframe } = usePickerQueryParamActions();
  const [searchParams] = useSearchParams();

  return (
    <div className="picker-full-screen-message">
      <Icon name="newInbox/Products/picker" xxxl />
      <h1>{getTextByKey("you-didnt-create-any-project")}</h1>
      <p>{getHtmlByKey("how-picker-can-help")}</p>
      {searchParams.get('q') ? <AdditionalSearchInfo /> : null}
      {isSubscribed() ? (
        <>
          <Button onClick={() => openIframe("create")}>
            {/*@ts-ignore*/}
            {getTextByKey("convert-first-project")}
          </Button>
          <p className="picker-hint">{getTextByKey("try-picker-for-free")}</p>
        </>
      ) : (
        <Button>
          {/*@ts-ignore*/}
          <LinkToNewTab isNewTab page={"plans"}>
            {getTextByKey("see-plans")}
          </LinkToNewTab>
        </Button>
      )}
    </div>
  );
};

export default PickerFullScreenMessage;
